import React from 'react';
import { useTheme } from '../../../styles/ThemeContext';

const UserProfileIcon = ({ letter = 'J', color }) => {
  const { theme } = useTheme();
  
  // Use theme.primary if no color is provided
  const actualColor = color || theme.primary;
  
  // Get the first character and convert to uppercase
  const letterToDisplay = letter.charAt(0).toUpperCase();

  return (
    <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="white"/>
      <text
        x="24"
        y="24"
        textAnchor="middle"
        dominantBaseline="central"
        fill={actualColor}
        fontWeight="bold"
        fontSize="24"
        fontFamily="Arial, sans-serif"
        style={{ userSelect: 'none' }}
      >
        {letterToDisplay}
      </text>
    </svg>
  );
};

export default UserProfileIcon;